<template>
  <div id="app">
    <router-view :key="$route.fullpath"/>
  </div>
</template>

<script>

export default {
	name: 'App',
	data () {
		return {
      pathArr:[
        {pcPath: '/service',mPath:'/read_al'}, //epub
        {pcPath: '/readerPDF',mPath:'/mreaderPDF'}, // pdf
        {pcPath: '/pcCatalog',mPath:'/mCatalog'}, // 图库
        {pcPath: '/pcExam',mPath:'/mobiExamStart'}, //试卷
        {pcPath: '/pcExercises',mPath:'/mobiExercises'}, //习题
      ]
		}
	},
  watch: {
    $route: {
      handler: function(to, from) {
        let thePath = to.path
        let fullPath = to.fullPath
        window.sessionStorage.removeItem('catalogDingwei')
        for(let i=0;i<this.pathArr.length;i++){
          if(thePath == this.pathArr[i].pcPath){
            if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)  || this.isiPad()) {
              let mPath = fullPath.replace(this.pathArr[i].pcPath, this.pathArr[i].mPath)
              window.location.href = process.env.READ_PLATFORM_PATH + mPath
            } else {
              return;
            }
          }
          if(thePath == this.pathArr[i].mPath){
            if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)  || this.isiPad()) {
              return;
            } else {
              let pcPath = fullPath.replace(this.pathArr[i].mPath, this.pathArr[i].pcPath)
              window.location.href = process.env.READ_PLATFORM_PATH + pcPath
            }
          }
        }
      }
    }
  },
  methods:{
    isiPad() {
        return (/macintosh|mac os x/i.test(navigator.userAgent) && window.screen.height > window.screen.width && !navigator.userAgent.match(/(iPhone\sOS)\s([\d_]+)/)) || navigator.userAgent.match(/(iPad).*OS\s([\d_]+)/);
    }
  }
}
</script>

<style>
#app{
  /* height:100%; */
  /* -webkit-touch-callout: none !important; 
  -webkit-user-select: none;  */
}
/* * {
   -webkit-user-select:none;
   -moz-user-select:none;
   -ms-user-select:none;
   user-select:none;	
} */
.el-popup-parent--hidden /deep/ .read_drawer #el-drawer__title{
    display: none;
  }
  div[name="Img.Math"] {
    margin-top: 18px !important;
    margin-bottom: 18px !important;
    width: auto !important;
    height:  auto !important;
    vertical-align: text-top;
    margin-top: 40px !important;
    margin-bottom: 40px !important;
}
body{margin: 0 !important;}
</style>



// WEBPACK FOOTER //
// src/App.vue